import type { ThresholdSimDisableReason } from './types';
import { thresholdSimDisableReason } from './types';
// TODO: IMPROVE1-413-update-threshold-types-score-value - need to investigate a real solution for this
export const MONETARY_MLA_KEYWORDS = ['account balance', 'average amount', 'sum'];
export const DEFAULT_SELECTED_RANGE = 30;
export const TAG_OPERATORS = ['set', 'not set'];

export const thresholdSimDisabledMessages: Record<ThresholdSimDisableReason, string> = {
  [thresholdSimDisableReason.invalidDataType]: 'Threshold Simulator does not yet support the rule type you have selected. Please select a rule with numerical thresholds.',
  [thresholdSimDisableReason.invalidOperator]: 'Threshold Simulator does not currently support the selected operator.',
  [thresholdSimDisableReason.invalidSave]: 'Threshold Simulator is only supported if the workflow was saved in the Next-Gen Editor',
  [thresholdSimDisableReason.invalidThreshold]: '',
  [thresholdSimDisableReason.insufficientEvaluations]: '{{evalsNeeded}} more evaluations are needed in order to run Threshold Simulator.',
  [thresholdSimDisableReason.lhsChanged]: 'Threshold Simulator can only be used when changing the threshold value and/or operator.',
  [thresholdSimDisableReason.pendingData]: 'Required Threshold Simulator data is still loading.',
};
